import { render, staticRenderFns } from "./SidFontFamily.vue?vue&type=template&id=4daa7b70"
import script from "./SidFontFamily.vue?vue&type=script&lang=js"
export * from "./SidFontFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports